import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  SendStepUpCodePayload,
  StepUpTokenDTO,
  VerifyStepUpCodePayload
} from '@sollapay/types';

export const stepUpApi = {
  sendCode: (client: HttpClient, payload: SendStepUpCodePayload): Promise<void> =>
    client.post<void, SendStepUpCodePayload>('/step-up/send-code', payload),
  verifyCode: (
    client: HttpClient,
    payload: VerifyStepUpCodePayload
  ): Promise<ApiResponse<StepUpTokenDTO>> =>
    client.post<ApiResponse<StepUpTokenDTO>, VerifyStepUpCodePayload>('/step-up/verify', payload)
};
